module.exports = class BilateralAgreementCountryModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.country = obj.country;
    this.ir = parseFloat(obj.ir) || 0;
    this.createdAt = obj.createdAt;
    this.updatedAt = obj.updatedAt;
  }
};